import * as React from 'react'
const MenuSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path d="M64 64h896v128H64V64zm0 768h896v128H64V832zm0-384h896v128H64V448z" />
  </svg>
)
export default MenuSvg
